// extracted by mini-css-extract-plugin
module.exports = {"ring":"PulseDotAnimation_ring__YcRPN","pulse":"PulseDotAnimation_pulse__thMWd"};